import { MdsDropdownContentList } from "@/design-system/components/dropdown";
import { MDSButton, MDSButtonIcon, MDSButtonSlotName, MDSButtonVariant } from "@/mds";
import {
  MdsHoverContent,
  MdsHoverContentPlacement,
} from "@/design-system/components/hover-content/MdsHoverContent";
import { MdsIconKind } from "@/design-system/components/icon";
import { MdsDropdownContent } from "@/design-system/components/dropdown/MdsDropdownContent";

export const HoverActions = ({
  label,
  iconKind,
  contentList,
}: {
  label: string;
  iconKind?: MdsIconKind;
  contentList: MdsDropdownContentList;
}) => {
  return (
    <MdsHoverContent
      content={() => <MdsDropdownContent contentList={contentList} />}
      placement={MdsHoverContentPlacement.Above}
    >
      <MDSButton variant={MDSButtonVariant.Subtle}>
        {iconKind && <MDSButtonIcon slot={MDSButtonSlotName.LeftIcon} kind={iconKind} />}
        {label}
        <MDSButtonIcon slot={MDSButtonSlotName.RightIcon} kind={MdsIconKind.AngleDown} />
      </MDSButton>
    </MdsHoverContent>
  );
};
